import SpecialsPage from 'src/dispensary/specials';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(SpecialsPage, MainDispensaryLayout);
